import axios from 'axios'
import { API_URL, RECEIPT_API_URL } from '../apiUrl.js'
import { parseSearch } from './searchParams.js'

import {
  GET_SALE_ITEM_REQUEST,
  GET_SALE_ITEM_SUCCESS,
  GET_SALE_ITEM_FAIL
} from '../constants/saleConstants'

import {
  GENERATE_RECEIPT_REQUEST,
  GENERATE_RECEIPT_SUCCESS,
  GENERATE_RECEIPT_FAILED,
  RETURNS_REQUEST,
  RETURNS_SUCCESS,
  RETURNS_FAILED,
  RETURN_ITEMS_REQUEST,
  RETURN_ITEMS_SUCCESS,
  RETURN_ITEMS_FAILED
} from '../constants/posConstants'

// Get all sale items
export const salesList =
  (pageNumberpos = '', wordradio = '') =>
  async (dispatch) => {
    const { keyword, field } = parseSearch(wordradio)

    axios.defaults.withCredentials = true

    try {
      dispatch({ type: GET_SALE_ITEM_REQUEST })

      const { data } = await axios.get(`${API_URL}/pos/list`, {
        headers: { 'Content-Type': 'application/json' },
        params: { pageNumberpos, keyword, field }
      })

      dispatch({ type: GET_SALE_ITEM_SUCCESS, payload: data })
    } catch (err) {
      dispatch({
        type: GET_SALE_ITEM_FAIL,
        payload:
          err.response && err.response.data.message ?
            err.response.data.message
          : err.message
      })
    }
  }

// Generate receipt
export const generateReceipt =
  (elementspkg, outSidedata) => async (dispatch) => {
    axios.defaults.withCredentials = true

    const { qrid, qfname, barcode } = outSidedata

    try {
      dispatch({ type: GENERATE_RECEIPT_REQUEST })

      const config = {
        headers: {
          'Content-Type': 'application/json'
        }
      }

      const { data } = await axios.put(
        `${API_URL}/pos/generate/?qfname=${encodeURIComponent(qfname)}&barcode=${encodeURIComponent(barcode)}&qrid=${encodeURIComponent(qrid)}`,
        elementspkg,
        config
      )

      dispatch({ type: GENERATE_RECEIPT_SUCCESS, payload: data })
    } catch (err) {
      dispatch({
        type: GENERATE_RECEIPT_FAILED,
        payload:
          err.response && err.response.data.message ?
            err.response.data.message
          : err.message
      })
    }
  }

export const getReceiptJobStatus = (jobId) => async () => {
  axios.defaults.withCredentials = true

  const { data } = await axios.get(
    `${RECEIPT_API_URL}/jobs/${encodeURIComponent(jobId)}`
  )
  return data
}

// Get receipt for returns
export const getreturnsReceipt = (barcode) => async (dispatch) => {
  axios.defaults.withCredentials = true

  try {
    dispatch({ type: RETURNS_REQUEST })

    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    }

    const { data } = await axios.get(
      `${API_URL}/pos/returns?barcode=${encodeURIComponent(barcode)}`,
      config
    )

    dispatch({ type: RETURNS_SUCCESS, payload: data })
  } catch (err) {
    dispatch({
      type: RETURNS_FAILED,
      payload:
        err.response && err.response.data.message ?
          err.response.data.message
        : err.message
    })
  }
}

// Update receipt for returns
export const returnsUpdate = (returninfo) => async (dispatch) => {
  axios.defaults.withCredentials = true

  try {
    dispatch({ type: 'RETURNS_UPDATE_REQUEST' })

    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    }

    const { data } = await axios.put(
      `${API_URL}/pos/returns/update`,
      returninfo,
      config
    )

    dispatch({ type: 'RETURNS_UPDATE_SUCCESS', payload: data })
  } catch (err) {
    console.error(err)
    dispatch({
      type: 'RETURNS_UPDATE_FAILED',
      payload:
        err.response && err.response.data.message ?
          err.response.data.message
        : err.message
    })
  }
}

// Return items from a recorded sale; the server restocks inventory
export const returnItems = (barcode, items) => async (dispatch) => {
  axios.defaults.withCredentials = true

  try {
    dispatch({ type: RETURN_ITEMS_REQUEST })

    const { data } = await axios.post(
      `${API_URL}/pos/returns/items`,
      { barcode, items },
      { headers: { 'Content-Type': 'application/json' } }
    )

    dispatch({ type: RETURN_ITEMS_SUCCESS, payload: data })
  } catch (err) {
    dispatch({
      type: RETURN_ITEMS_FAILED,
      payload:
        err.response && err.response.data.message ?
          err.response.data.message
        : err.message
    })
  }
}
